import TransactionService from '@/services/TransactionService'
import xmlUtils from '@/utils/XmlUtils.vue'

export default {
  actions: {
    async fetchTransactionNexusSummary (ctx, limit) {
      const transactionNexusSummary = await TransactionService.methods.getTransactionNexusSummary(limit)
      ctx.commit('updateTransactionNexusSummary', transactionNexusSummary.TransactionNexusSummaryResponse.TransactionNexusSummary.TransactionNexusSummaryItem)
    },
    async fetchTransactionSummary (ctx, [limit, listAllStatus]) {
      const transactionSummary = await TransactionService.methods.getTransactionSummary(limit, listAllStatus)
      ctx.commit('updateTransactionSummary', transactionSummary.TransactionSummaryResponse.TransactionSummary)
    },
    async fetchTransactionDetails (ctx, transactionNumber) {
      const transactionDetails = await TransactionService.methods.getTransactionDetails(transactionNumber)
      ctx.commit('updateTransactionDetails', transactionDetails.TransactionDetailsResponse.TransactionData)
    }
  },
  mutations: {
    updateTransactionNexusSummary (state, transactionNexusSummary) {
      const mapper = transaction => {
        return {
          date: transaction.DateTime._text,
          exchangeRate: transaction.ExchangeRate._text,
          txnConsumer: {
            c_email: transaction.TxnConsumer.C_Email._text,
            c_id: transaction.TxnConsumer.C_ID._text,
            c_mobile: transaction.TxnConsumer.C_Mobile._text,
            c_name: transaction.TxnConsumer.C_Name._text
          },
          referenceNumber: transaction.ReferenceNumber._text,
          recipientId: transaction.RecipientID._text,
          number: transaction.Number._text,
          recipientName: transaction.RecipientName._text,
          remittanceGatewayId: transaction.RemittanceGatewayId._text,
          sourceAmount: transaction.SourceAmount._text,
          sourceCurrency: transaction.SourceCurrency._text,
          targetAmount: transaction.TargetAmount._text,
          targetCurrency: transaction.TargetCurrency._text,
          transactionStatus: transaction.TransactionStatus._text,
          transactionType: transaction.TransactionType._text,
          fundingTxnDetails: {
            fundingTxnDetail_Fee: transaction.FundingTxnDetails.FundingTxnDetail_Fee._text,
            fundingTxnDetail_Id: transaction.FundingTxnDetails.FundingTxnDetail_Id._text,
            fundingTxnDetail_RefNo: transaction.FundingTxnDetails.FundingTxnDetail_RefNo._text,
            fundingTxnDetail_Status: transaction.FundingTxnDetails.FundingTxnDetail_Status._text,
            fundingTxnDetail_Time: transaction.FundingTxnDetails.FundingTxnDetail_Time._text,
            fundingTxnDetail_TotalAmount: transaction.FundingTxnDetails.FundingTxnDetail_TotalAmount._text,
            fundingTxnLastUpdate_Time: transaction.FundingTxnDetails.FundingTxnLastUpdate_Time._text,
            fundingType: transaction.FundingTxnDetails.FundingType._text
          },
          moneyTransferTxnDetails: Object.keys(transaction.MoneyTransferTxnDetails).length > 1 ? {
            exchangeRate: transaction.MoneyTransferTxnDetails.ExchangeRate._text,
            moneyTransferLastUpdate_Time: transaction.MoneyTransferTxnDetails.MoneyTransferLastUpdate_Time._text,
            moneyTransferTxnDetail_Id: transaction.MoneyTransferTxnDetails.MoneyTransferTxnDetail_Id._text,
            moneyTransferTxnDetail_RefNo: transaction.MoneyTransferTxnDetails.MoneyTransferTxnDetail_RefNo._text,
            moneyTransferTxnDetail_Time: transaction.MoneyTransferTxnDetails.MoneyTransferTxnDetail_Time._text,
            moneyTransferTxn_Fee: transaction.MoneyTransferTxnDetails.MoneyTransferTxn_Fee._text,
            moneyTransferTxn_ReceiveAmount: transaction.MoneyTransferTxnDetails.MoneyTransferTxn_ReceiveAmount._text,
            moneyTransferTxn_TotalAmt: transaction.MoneyTransferTxnDetails.MoneyTransferTxn_TotalAmt._text,
            remitStatus: transaction.MoneyTransferTxnDetails.RemitStatus._text,
            remittanceGateway: transaction.MoneyTransferTxnDetails.RemittanceGateway._text
          } : transaction.MoneyTransferTxnDetails._attributes,
          promoTxnDetails: transaction.PromoTxnDetails._attributes
        }
      }
      state.transactionNexusSummary = Array.isArray(transactionNexusSummary) ? transactionNexusSummary.map(mapper) : transactionNexusSummary ? [transactionNexusSummary].map(mapper) : []
    },
    updateTransactionSummary (state, transactionSummary) {
      if ((Array.isArray(transactionSummary) && transactionSummary.length) || (typeof transactionSummary === 'object' && Object.keys(transactionSummary).length)) {
        const _transactionSummary = Array.isArray(transactionSummary) ? transactionSummary : [transactionSummary]
        state.transactionSummary = _transactionSummary
          .map(transaction => {
            (Object.values(transaction).map((e, key) => {
              const objectKey = Object.keys(transaction)[key].charAt(0).toLowerCase() + Object.keys(transaction)[key].slice(1)
              transaction[objectKey] = e._text
            }))
            return transaction
          })
      } else {
        state.transactionSummary = []
      }
      localStorage.setItem('has-transactions', state.transactionSummary.length > 0)
    },
    updateTransactionDetails (state, transactionDetails) {
      state.transactionDetails = [transactionDetails].map(transaction => {
        (Object.values(transaction).map((e, key) => {
          const objectKey = Object.keys(transaction)[key].charAt(0).toLowerCase() + Object.keys(transaction)[key].slice(1)
          if (objectKey === 'remittanceData') {
            const childObject = xmlUtils.methods.getParseObjectFromXml(e._text).MoneyTransferRequestSavedData
            transaction[objectKey] = {}
            Object.entries(childObject).map(([keyChild, valueChild]) => {
              const objectKeyChild = keyChild.charAt(0).toLowerCase() + keyChild.slice(1)
              if (objectKeyChild === 'promoCodeData') {
                transaction[objectKey][objectKeyChild] = {
                  amount: valueChild.hasOwnProperty('Amount') ? valueChild.Amount._text : parseFloat(0).toFixed(2),
                  code: valueChild.hasOwnProperty('Amount') ? valueChild.Code._text : null,
                  issue: valueChild.hasOwnProperty('Amount') ? valueChild.Issue._text : null,
                  remittanceGateway: valueChild._text
                }
              } else {
                transaction[objectKey][objectKeyChild] = valueChild._text
              }
            })
          } else {
            transaction[objectKey] = e._text
          }
        }))
        return transaction
      })
    }
  },
  getters: {
    getTransactionNexusSummary (state) {
      return state.transactionNexusSummary
    },
    getTransactionSummary (state) {
      return state.transactionSummary
    },
    getTransactionDetails (state) {
      return state.transactionDetails
    },
    isHasTransactions (state) {
      return state.transactionSummary.length > 0 || JSON.parse(localStorage.getItem('has-transactions')) || true
    }
  },
  state: {
    transactionDetails: null,
    transactionSummary: [],
    transactionNexusSummary: [],
    hasTransactions: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/transaction.js